<template>
  <div class="card">
    <div
      v-b-toggle="`collapsePublications`"
      class="card-header"
    >
      <h3
        :id="`field-2`"
        class="cart-title"
      >
        <a data-action="collapse">{{ field.label ? field.label : field.name }}</a>
      </h3>
      <b-tooltip
        :key="`field-custom-2`"
        placement="topleft"
        boundary="document"
        triggers="hover"
        :target="`field-2`"
        :title="field.tooltip"
      />
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
          <!-- <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              @click="redirectuser($event, [{user_id: userId}, 'researcher.publications.index'])"
            ><i data-feather="edit-3" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapsePublications`"
      v-model="isToggled"
    >
      <div
        class="card-content"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col">
              <div class="abridged-cv__list">
                <div
                  v-for="publication in scientificPublications"
                  :key="'pub-' + publication.id"
                  class="publication-item d-flex align-items-start"
                >
                  <template v-if="canSee(publication)">
                    <div
                      v-if="fromPromotion && convo.days > 0 && isResearcher"
                      class="form-check form-check-success form-switch me-2"
                    >
                      <input
                        :id="'publishContent' + publication.id"
                        type="checkbox"
                        class="form-check-input"
                        :checked="selectedPublications.includes(publication.id.toString())"
                        @change="handlePublicationClick(publication, $event)"
                      >
                    </div>
                    <div class="publication-content">
                      <span
                        class="publication-span"
                        v-html="publication.full_reference"
                      />
                      <span class="text-danger">{{ publication.publication_status_id === 25 ? ' (Accepted)' : '' }}</span>
                      <a
                        class="ms-1 btn btn-sm bg-light-secondary"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Edit"
                        @click="redirectuser($event, [{ id: publication.id }, 'researcher.publications.edit'])"
                      >
                        <i data-feather="edit-3" />
                      </a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<style scoped>
.publication-item {
  list-style: none;
  position: relative;
  padding-left: 2.5rem;
  margin-bottom: 0.5rem;
}

.publication-content {
  flex: 1;
}

.form-check {
  margin-left: -2rem;
  padding-left: 0;
}

.form-switch .form-check-input {
  margin-left: 0;
  margin-top: 0.25rem;
}
</style>

<script>
import { mapGetters } from 'vuex'
import { BCollapse, BTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
    BTooltip,
  },
  props: {
    userId: { type: Number, required: true, default: () => {} },
    yearBetween: { type: Object, required: true, default: () => {} },
    field: { type: Object, required: true },
    fromPromotion: { type: Boolean, required: false },
    promo: { type: Object, required: false, default: () => {} },
    hasSelect: { type: Boolean, required: false, default: () => false },
  },
  data() {
    return {
      loading: true,
      isToggled: true,
    }
  },
  computed: {
    ...mapGetters({
      scientificPublications: 'users/scientificPublications',
      selectedPublications: 'convo/selectedPublications',
      toggled: 'preview/toggled',
      convo: 'convo/convo',
      loggedUser: 'auth/admin',
    }),
    isResearcher() {
      return this.loggedUser.roles.includes('researcher')
    },
  },
  watch: {
    userId() {
      this.reloadData()
    },
    toggled() {
      if (this.toggled !== this.isToggled) {
        this.isToggled = this.toggled
      }
    },
    yearBetween() {
      this.reloadData()
    },
  },
  async mounted() {
    await this.reloadData()
    if (this.fromPromotion) {
      await this.loadSelectedPublications()
    }
  },
  methods: {
    canSee(publication) {
      if (this.loggedUser.roles.includes('super-admin') && this.convo.year < 2026) {
        return true
      }
      if (!this.fromPromotion || this.convo.year < 2026) return true
      if (this.isResearcher) {
        return this.convo.days > 0 || this.selectedPublications.includes(publication.id.toString())
      }
      // For non-researchers, only show selected publications
      return this.selectedPublications.includes(publication.id.toString())
    },
    async loadSelectedPublications() {
      try {
        await this.$store.dispatch('convo/fetchSelectedPromotionScientificProductions', {
          origenableType: 'App\\Models\\Publication',
          userId: this.userId,
        })
      } catch (error) {
        console.error('Error loading selected publications:', error)
      }
    },
    async reloadData() {
      this.loading = true
      this.isToggled = this.toggled

      if (this.promo && this.promo.id && !this.promo.active_researcher) {
        await this.$store.dispatch('users/fetchUserScientificPublicationsFreezed', { convo: this.promo.id, userId: this.userId, yearBetween: this.yearBetween })
      } else if (this.fromPromotion) {
        await this.$store.dispatch('users/fetchUserScientificPublications', { userId: this.userId, yearBetween: this.yearBetween, fromPromotion: this.fromPromotion })
      } else {
        await this.$store.dispatch('users/fetchUserScientificPublications', { userId: this.userId, yearBetween: this.yearBetween })
      }

      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
      this.loading = false
    },
    async redirectuser(event, redirection) {
      event.stopPropagation()
      this.$emit('goToIndex', redirection)
    },
    handlePublicationClick(publication, event) {
      // Get the current checkbox state from the event
      const isChecked = event.target.checked

      this.$emit('item-selected', {
        origenable_id: publication.id, // This is the actual publication ID
        type: 'App\\Models\\Publication',
        selected: isChecked, // Use the actual checkbox state
      })
    },
  },
}
</script>
